import PropTypes from 'prop-types';
import { Action, Alert } from '@reverse-hr/pattern-library';
import { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const DownloadFileButton = ({
  className,
  fileName = '',
  iconPosition = 'left',
  label,
  onClick,
  variant = 'simple-text',
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchFailed, setIsFetchFailed] = useState(null);

  const wrapperClassNames = classNames('c-download-file-button', className, {
    'c-download-file-button--loading': isLoading,
  });

  const onDownloadClick = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    setIsFetchFailed(false);

    try {
      const { filename: fetchedFileName, url } = await onClick();
      const virtualLink = document.createElement('a');

      virtualLink.href = url;
      virtualLink.download = fileName || fetchedFileName;
      virtualLink.click();
    } catch (error) {
      setIsFetchFailed(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={wrapperClassNames}>
      <Action
        type={variant}
        label={label}
        icon={isLoading ? 'icn-refresh' : 'icn-download'}
        iconPosition={iconPosition}
        onClick={onDownloadClick}
      />

      {isFetchFailed && (
        <Alert
          type="negative"
          icon="icn-warning-outline"
          closable
          modifier="c-alert--fixed c-download-file-button__alert"
        >
          {t('general.error.title')}
        </Alert>
      )}
    </div>
  );
};

DownloadFileButton.propTypes = {
  className: PropTypes.string,
  fileName: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
